<!-- Footer Component -->
<script>
  import { Col, Row, Container } from "sveltestrap";
</script>

<!--START FOOTER-->
<footer class="footer">
  <Container>
    <Row>
      <Col lg="3" class="mt-4">
        <h4>All Axis</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#"}>Home</a></li>
            <li><a href={"#services"}>Services</a></li>
            <li><a href={"#ourway"}>Our Way</a></li>
            <li><a href={"#ourway"}>Certifications</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>Information</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#team"}>About us</a></li>
            <li><a href={"#contact"}>Contact us</a></li>
            <li><a href={"#pricing"}>Pricing</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>Support</h4>
        <div class="text-muted mt-4">
          <ul class="list-unstyled footer-list">
            <li><a href={"#contact"}>Contact Us</a></li>
          </ul>
        </div>
      </Col>
      <Col lg="3" class="mt-4">
        <h4>All Axis Home Inspections</h4>
        <div class="text-muted mt-4">
          <p>
             NJ License # 24GI00200220
          </p>
        </div>        
        <div class="text-muted mt-4">
          <p>
            {new Date().getFullYear()}© All Axis - All rights reserved.  
          </p>
        </div>
      </Col>
    </Row>
  </Container>
</footer>
<!--END FOOTER-->

<!--START FOOTER ALTER-->
<!-- <div class="footer-alt">
  <Container>
    <Row>
      <Col lg="12">
        <div class="float-start pull-none ">
          <p class="copy-rights text-muted">
            {new Date().getFullYear()}
            © All Axis
          </p>
        </div>
        <div class="clearfix" />
      </Col>
    </Row>
  </Container>
</div> -->
<!--START FOOTER ALTER-->
